import React from 'react'
import SEO from '../components/SEO'
import Layout from '../components/Layout'

class AboutPage extends React.Component {
  render() {

    return (
      <Layout location={this.props.location}>
        <div style={{ background: '#fff' }}>
          <SEO title="About" />
          <h1 className="mb-8 leading-loose font-extrabold text-4xl text-center">
            About Us
          </h1>
          <div className="about-wrapper">
            This blog is dedicated to good design. Good design can make the difference between your message reaching your audience or 
            falling flat.<br/><br/> 
            It can be the deciding factor in your brand standing out. It is important to invest the time and resources into making sure
            your product, whether that is a newsletter, email, brochure or merchandise, is well designed.<br/><br/> 
            If you would like assistance in designing your creative, please check out our affiliate {" "}
            <a style={{fontWeight:'bold', textDecoration:'none'}} href="https://www.kimp.io/?partner=designguru" target="_blank" rel="noreferrer noopener">agencies</a>.

          </div>
        </div>
      </Layout>
    )
  }
}


export default AboutPage